import script from "./_company-logo.vue?vue&type=script&setup=true&lang=js"
export * from "./_company-logo.vue?vue&type=script&setup=true&lang=js"

import "./_company-logo.vue?vue&type=style&index=0&id=5ecc31b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ecc31b6"]])

export default __exports__